<template>
  <div>
    <TheDemandHeader
      :is-center="true"
      :title="pickUpCountDown"
      page="confirmation"
    />
    <TheDemandComfirmation :reservation="Reservation" />
    <TheDemandBottomCancel :reservation="Reservation" />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import moment from "@/services/moment";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateDemandConfirmation",
  props: {
    Reservation: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    console.log("props.Reservation :>> ", props.Reservation);
    const store = useStore();

    const pickUpCountDown = computed(() => {
      switch (props.Reservation.status) {
        case "BOARDING":
          return "乗車中";
        case "FINISHED":
          return "降車済";
        case "CANCELED":
          return "予約がキャンセルされました";
      }
      var current = moment(new Date());
      var pickUpTime = moment(
        new Date(props.Reservation.latestEstimatePickUpTime)
      );
      return pickUpTime.diff(current, "minutes") > 0
        ? `車の到着まで約${pickUpTime.diff(current, "minutes")}分`
        : "もう間も無く到着します";
    });

    return {
      pickUpCountDown,
    };
  },
};
</script>
